/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var MultiColumnComboBoxValueChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboBoxValueChangedEventArgs, _super);
    function MultiColumnComboBoxValueChangedEventArgs(a, b) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.b = null;
        _this.d = a;
        _this.b = b;
        return _this;
    }
    Object.defineProperty(MultiColumnComboBoxValueChangedEventArgs.prototype, "oldValue", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBoxValueChangedEventArgs.prototype, "newValue", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    MultiColumnComboBoxValueChangedEventArgs.$t = markType(MultiColumnComboBoxValueChangedEventArgs, 'MultiColumnComboBoxValueChangedEventArgs', EventArgs.$);
    return MultiColumnComboBoxValueChangedEventArgs;
}(EventArgs));
export { MultiColumnComboBoxValueChangedEventArgs };
//# sourceMappingURL=MultiColumnComboBoxValueChangedEventArgs.js.map
